import { render } from "./DashobardSIMPage.vue?vue&type=template&id=94126520"
import script from "./DashobardSIMPage.vue?vue&type=script&lang=js"
export * from "./DashobardSIMPage.vue?vue&type=script&lang=js"

import "./DashobardSIMPage.vue?vue&type=style&index=0&id=94126520&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__